import { useState, useEffect } from 'react';
import { Modal, Button } from '@components/ui';
import { kazikDurumlari, testDurumlari } from '@mocks/materials/foreKazik';

export default function DurumModal({ isOpen, onClose, onSubmit, data, isLoading = false }) {
    const [durum, setDurum] = useState('');
    const [testDurumu, setTestDurumu] = useState('');
    const [not, setNot] = useState('');

    useEffect(() => {
        if (data) {
            setDurum(data.durum || 'planlandi');
            setTestDurumu(data.testDurumu || 'bekliyor');
        }
    }, [data]);

    const handleSubmit = () => {
        onSubmit({ durum, testDurumu, not });
    };

    if (!data) return null;

    const selectClass = "w-full px-3 py-2.5 bg-bg-primary border border-border-light rounded-lg text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-primary/50";

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Kazık Durumu Güncelle" size="sm"
            footer={<><Button variant="ghost" onClick={onClose} disabled={isLoading}>İptal</Button><Button variant="success" onClick={handleSubmit} isLoading={isLoading}>Güncelle</Button></>}>
            <div className="space-y-4">
                <div className="p-3 bg-bg-tertiary rounded-lg text-center">
                    <p className="text-2xl font-mono font-bold text-primary">{data.kazikNo}</p>
                    <p className="text-sm text-text-muted">{data.blok} - {data.konum}</p>
                </div>

                <div>
                    <label className="block text-sm font-medium text-text-primary mb-1.5">İmalat Durumu</label>
                    <select value={durum} onChange={(e) => setDurum(e.target.value)} className={selectClass}>
                        {kazikDurumlari.map(d => <option key={d.key} value={d.key}>{d.label}</option>)}
                    </select>
                </div>

                <div>
                    <label className="block text-sm font-medium text-text-primary mb-1.5">Test Durumu</label>
                    <select value={testDurumu} onChange={(e) => setTestDurumu(e.target.value)} className={selectClass}>
                        {testDurumlari.map(t => <option key={t.key} value={t.key}>{t.label}</option>)}
                    </select>
                </div>

                <div>
                    <label className="block text-sm font-medium text-text-primary mb-1.5">Not</label>
                    <input type="text" value={not} onChange={(e) => setNot(e.target.value)} placeholder="Güncelleme notu..." className={selectClass} />
                </div>
            </div>
        </Modal>
    );
}
